import { render, staticRenderFns } from "./InTheNews.vue?vue&type=template&id=1d6fc5ab&scoped=true&"
import script from "./InTheNews.vue?vue&type=script&lang=js&"
export * from "./InTheNews.vue?vue&type=script&lang=js&"
import style0 from "./InTheNews.vue?vue&type=style&index=0&id=1d6fc5ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fc5ab",
  null
  
)

export default component.exports